import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import PropTypes from "prop-types";
import localStorages from 'store';

import { getFinish, createTemporalDetails } from '../../lib/ApiServices';


import { fetchPayment, fetchCheck, fetchFinish } from '../../routers/settings'
import { hideMessage } from '../../routers/messages'
import DialogError from './components/dialogError'

import FirstHeader from '../components/firstHeader'
import Header from '../components/header'
import SecondHeader from '../components/secondHeader'
import Footer from '../components/footer'

import PanelBreakdown from './components/panelBreakdown'
import PanelBooking from './components/panelBooking'
import PanelPassangers from './components/panelPassangers'
import PanelVehicles from './components/panelVehicles'
import PanelTowing from './components/panelTowing'

class routeResume extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  constructor(props) {
    super(props);
    this.state = {
      openWindows: false,
    };
  }

  isMobileDevice = () => {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
  }


  componentDidUpdate(prevProps, prevState) {
    const lang = this.context.router.route.location.pathname.split('/')[1]
    const { to } = this.props.messages
    if (to !== undefined) {
      this.context.router.history.push(`/${lang}${to}`);
    }

    const payment = this.props.data.payment
    if (payment !== undefined && !this.state.openWindows) {
      this.setState({ openWindows: true })
      if (localStorages.get('token')) {
        // when we have token it means "port mode" so we finish payment right here
        getFinish(this.props.data).then((res) => {
            if (res.response === 'success') {
              const ref = payment.order.reference
              this.context.router.history.push(`/${lang}/confirmation?reference=${ref}`)
            } else {
              this.context.router.history.push(`/${lang}/confirmation?reference=error`)
            }
          });
      } else {
        // go to bank site to pay
        this.openWindowWithPost(payment)
      }
    }
  }

  handleClose = () => {
    const lang = this.context.router.route.location.pathname.split('/')[1]
    this.props.hideMessage()
    this.context.router.history.push(`/${lang}/data`)
    window.scrollTo(0, 0)
  };

  handleCheck = () => {
    const reference = this.props.data.payment.order.reference
    this.props.fetchCheck(reference)
  };

  handleFinish = () => {
    const { settings, data } = this.props
    const reference = this.props.data.payment.order.reference
    this.props.fetchFinish(settings, data)
    this.props.fetchCheck(reference)
  };

  handleCancel = () => {
    this.props.hideMessage()
  };

  onClickNext = (evt) => {
        const langUrl = this.context.router.route.location.pathname.split('/')[1]
        const { settings, data } = this.props
        this.props.fetchPayment(settings, data, langUrl)
        this.setState({ openWindows: false })
  }

  openWindowWithPost = (payment) => {
    let form = document.createElement("form");
    form.target = "_parent";
    form.method = "POST";
    form.action = payment.url
    form.style.display = "none";

    for (let key in payment.params) {
      let input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = payment.params[key];
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }

  editDetails = () => {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    this.context.router.history.push(`/${langUrl}/data`)
    document.querySelector('.second-header').classList.remove('js-is-sticky');
    window.scrollTo(window.scrollX, 0);
  }


  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].resume

    const { passangers, vehicles } = this.props.settings.definedData
    const { nAdults, nTeens, nKids, nBabies } = this.props.data.values
    const { nCars, nVans, nMotorcycles, nTowing } = this.props.data.values

    const nVehicles = nCars + nVans + nMotorcycles + nTowing
    const nPassangers = nAdults + nTeens + nKids + nBabies

    const actions = []//[<FlatButton label="Cancelar" primary={true} onClick={this.handleCancel}/>,
    // <FlatButton label="Simulación de pago" primary={true} onClick={this.handleFinish}/>]
    let isMobile;
    if (this.isMobileDevice() === true) {
      isMobile = <SecondHeader step={2} mobile={true} />;
    }
    else {
      isMobile = <SecondHeader step={2} mobile={false} />
    }
    if (nPassangers) {
      return (
        <div>
          <DialogError messages={this.props.messages} handleClose={this.handleClose} actions={actions} />
          <FirstHeader />
          <Header />

          <div className='container-fluid route-resume'>
            {isMobile}
            <div className="second-header-placeholder"></div>

            <div className="row">
              <div className="container">
                <div className="flex-row ">
                  <div className='col-md-12 col-sm-12 col-xs-12'>

                    <div className='row section-middle-paragraph margin-top-50'>
                      {langPlace.infotext}
                    </div>

                    <div className='row separating-line margin-top-50'><hr /></div>

                    <PanelBreakdown />
                    <PanelBooking />
                    {(nPassangers > 0) ?
                      <div className='row'>
                        <div className='col-md-12 no-padding'>
                          <div className='separating-line margin-top-50'><hr /></div>

                          <div className='section-title'>{langPlace.passengersinfo}</div>
                          <div className='row'>
                            {passangers.map(({ name, title, count }, index) =>
                              <div key={index}>
                                {[...Array(this.props.data.values[count])].map((key, index) =>
                                  <PanelPassangers key={index} index={index + 1} name={name} title={title} />
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      : ''}
                    {(nVehicles > 0) ?
                      <div className='row'>
                        <div className='col-md-12 no-padding'>
                          <div className='separating-line margin-top-50'><hr /></div>
                          <div className='section-title'>{langPlace.vehiclesinfo}</div>
                          <div className='row'>
                            {vehicles.map(({ name, title, count }, index) =>
                              <div key={index}>
                                {[...Array(this.props.data.values[count])].map((key, index) => {
                                  switch (name) {
                                    case 'towing':
                                      return (<PanelTowing key={index} index={index + 1} name={name} title={title} />)
                                    default:
                                      return (<PanelVehicles key={index} index={index + 1} name={name} title={title} />)
                                  }
                                }
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      : ''}

                    <div className='row separating-line margin-top-50'><hr /></div>

                    <div className='row'>
                      <div className='col-lg-4 col-md-4 col-sm-5 col-xs-12 no-padding'>
                        <div className='edit-button button-next' onClick={this.editDetails}>
                          <i className="fa fa-angle-left" aria-hidden="true"></i>{langPlace.editdetails}
                        </div>
                      </div>
                      <div className='col-lg-4 col-md-8 col-sm-7 col-xs-0' />
                      <div className='col-lg-4 col-md-4 col-sm-5 col-xs-12 no-padding'>
                        <div className='general-button button-next' onClick={this.onClickNext}>
                          {langPlace.confirm}<i className="fa fa-angle-right" aria-hidden="true"></i>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>         
          <Footer />
        </div>
      )
    } else {
      return (<Redirect to={`/${langUrl}`} />);
    }
  }
}

export default connect(
  (state) => ({ settings: state.settings, data: state.data, messages: state.messages }),
  { fetchPayment, hideMessage, fetchCheck, fetchFinish }
)(routeResume)



// WEBPACK FOOTER //
// ./src/shared/routes/routeResume/index.js